var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex"},attrs:{"id":"head"}},[_c('img',{attrs:{"id":"logo","alt":"城堡","src":require("../images/heidelb.jpg")}}),_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('h2',[_vm._v(_vm._s(_vm.remark))])])
}
var staticRenderFns = []

export { render, staticRenderFns }